import { UnknownHollow } from '@clearkit/icons';
import classNames from 'classnames';
import { CKButton } from 'clearkit';
import { Link } from 'react-router-dom';

type MissingRecordProps = {
  type: 'person' | 'company';
  onClickRefetch: () => void;
};

const MissingRecord = ({ type, onClickRefetch }: MissingRecordProps) => {
  return (
    <div
      className={classNames('x-sidebar')}
      style={{
        background: '#FAFBFC',
        padding: 24,
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 13,
        color: '#596168',
        textAlign: 'center',
      }}
    >
      <UnknownHollow className="w-6 h-6 mb-2" />
      <p
        style={{
          maxWidth: 380,
          fontWeight: 500,
          fontSize: 14,
          color: '#596168',
          textAlign: 'center',
        }}
      >
        Sorry, we're unable to find that {type}.
      </p>

      <p
        style={{
          maxWidth: 380,
          marginBottom: 24,
        }}
      >
        We couldn't find any information about this {type}. If you're sure{' '}
        {type === 'person' ? 'this person' : 'this company'} should exist,{' '}
        <CKButton
          onClick={onClickRefetch}
          variant="tertiary"
          variantColor="blue"
        >
          try again
        </CKButton>
        .
      </p>

      <CKButton as={Link} to="/" variant="simple" variantColor="blue">
        Go to Home
      </CKButton>
    </div>
  );
};

export default MissingRecord;
